<template>
    <v-container>
        <div>
            <v-flex>
                <v-row>
                    <h1 class="page-title">Areas</h1>
                    <v-spacer class="line"></v-spacer>
                    <hr>
                    <new-area-modal></new-area-modal>
                </v-row>
            </v-flex>

            <v-flex sm="6" class="area-select">
                <v-row>
                    <v-select
                            clear-icon="mdi-close"
                            clearable
                            @click:clear="clearArea"
                            outlined
                            label="Select an Area"
                            required
                            v-model="areaSelected"
                            item-text="name"
                            item-value="id"
                            :items="areasList"
                            @change="filterRestaurantsByArea"
                    ></v-select>
                </v-row>
            </v-flex>

            <div v-if="areaData === null">
              <div class="areas-restaurants-table"
                 v-for="area_item in areasListPaged"
                 :key="area_item.id">
                <v-simple-table>
                    <thead>
                    <tr>
                        <th class="text-left" width="17%">City</th>
                        <th class="text-left" width="17%">Area</th>
                        <th class="text-left">Standard Pay (per hour)</th>
                        <th class="text-left">Weekend Pay (per hour)</th>
                        <th class="text-left"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{ getCityLabelById(area_item.city_id) }}</td>
                        <td>{{ area_item.name }}</td>
                        <td>£{{ area_item.standardPayRate | formatFloat}}</td>
                        <td>£{{ area_item.weekendPayRate | formatFloat}}</td>
                        <td>
                            <edit-area-modal :thisAreaData="area_item"></edit-area-modal>
                            <v-btn
                                small
                                color="warning"
                                class="float-right"
                                depressed
                                @click="deleteArea(area_item)"
                            >
                                <v-icon left>mdi-delete</v-icon>
                                Delete
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <!-- restaurants of this area -->
                <v-container class="inner-table text-right">
                    <h3 v-if="area_item.restaurants" class="text-left">Restaurants</h3>
                    <div v-if="!area_item.restaurants" class="text-left">
                        <span>No restaurants found in this area</span>
                    </div>
                    <v-simple-table
                            v-else
                            class="mb-3 text-left">
                        <thead v-if="area_item.restaurants">
                        <tr>
                            <th class="text-left" width="25%">Name</th>
                            <th class="text-left">Address</th>
                            <th class="text-right"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="restaurant of area_item.restaurants"
                            :key="restaurant.id"
                        >
                            <td>{{restaurant.name}}</td>
                            <td>
                                <restaurant-address-modal :thisRestaurantId="restaurant.id"></restaurant-address-modal>
                            </td>
                            <td class="text-right">
                                <v-btn-toggle class="edit-button-group">
                                    <edit-restaurant-modal :thisRestaurantData="restaurant"></edit-restaurant-modal>
                                    <template>
                                    <div class="text-center">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                        tile
                                                        small
                                                        class="primary dropdown-menu-activator"
                                                        depressed
                                                        v-on="on"
                                                ><v-icon>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="deleteRestaurant(restaurant)">
                                                    <v-list-item-title>Delete</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                        @click="goToSchedule(restaurant.id)"
                                                        :restaurantId="restaurant.id"
                                                >
                                                    <v-list-item-title>Schedule</v-list-item-title>
                                                </v-list-item>

                                                <drivers-list-modal :restaurantId="restaurant.id"></drivers-list-modal>

                                                <new-post-modal :restaurantId="restaurant.id"></new-post-modal>

                                            </v-list>
                                        </v-menu>
                                    </div>
                                    </template>
                                </v-btn-toggle>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                    <new-restaurant-modal :thisAreaData="area_item" small></new-restaurant-modal>
                </v-container>
              </div>
              <v-row>
                  <v-col cols="12" sm="2" md="2">
                      <v-flex class="d-flex flex-row">
                          <div style="min-width:75px" class="pt-2">
                              Per page:
                          </div>
                          <v-select
                              :items="per_page_list"
                              label="Solo field"
                              solo
                              dense
                              v-model="per_page"
                              v-on:change="onCangePerPage"
                              hide-details=""
                              disabled
                          ></v-select>
                      </v-flex>
                  </v-col>
                  <v-col cols="12" sm="8" md="8">
                  <v-pagination
                      :value="page"
                      :length="total_pages"
                      :total-visible="14"
                      @input="onChangePage"
                  ></v-pagination>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                      {{((page - 1) * per_page) + 1}}&nbsp;-&nbsp;{{ ((page * per_page) < areasList.length) ? (page * per_page) : areasList.length }}&nbsp;of&nbsp;{{areasList.length}}
                  </v-col>
              </v-row>
            </div>

            <!-- when area selected by filter -->
            <div v-if="areaData !== null"
                 class="areas-restaurants-table">
                <v-simple-table
                >
                    <thead>
                    <tr>
                        <th class="text-left">City</th>
                        <th class="text-left">Area</th>
                        <th class="text-left">Standard Pay (per hour)</th>
                        <th class="text-left">Weekend Pay (per hour)</th>
                        <th class="text-left"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{ getCityLabelById(areaData.city_id) }}</td>
                        <td>{{ areaData.name }}</td>
                        <td>£{{ areaData.standardPayRate | formatFloat }}</td>
                        <td>£{{ areaData.weekendPayRate | formatFloat }}</td>
                        <td>
                            <edit-area-modal :thisAreaData="areaData"></edit-area-modal>
                            <v-btn
                                small
                                color="warning"
                                class="float-right"
                                depressed
                                @click="deleteArea(areaData)"
                            >
                                <v-icon left>mdi-delete</v-icon>
                                Delete
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>

                <v-container class="text-right">
                    <h3 class="text-left" v-if="areaData.restaurants.length !== 0">
                        Restaurants</h3>
                    <div v-if="areaData.restaurants.length === 0" class="text-left">
                        <span>No restaurants found in this area</span>
                    </div>
                    <v-simple-table class="mb-3">
                        <thead v-if="areaData.restaurants.length !== 0">
                        <tr>
                            <th class="text-left">Name</th>
                            <th class="text-left">Address</th>
                            <th class="text-right"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="restaurant of areaData.restaurants"
                            :key="restaurant.id">
                            <td class="text-left">{{restaurant.name}}</td>
                            <td class="text-left">{{restaurant.address}}</td>
                            <td>
                                <v-btn-toggle class="edit-button-group">
                                    <edit-restaurant-modal :thisRestaurantData="restaurant"></edit-restaurant-modal>
                                    <template>
                                    <div class="text-center">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                        tile
                                                        small
                                                        class="primary dropdown-menu-activator"
                                                        depressed
                                                        v-on="on"
                                                ><v-icon>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="deleteRestaurant(restaurant)">
                                                    <v-list-item-title>Delete</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item
                                                        @click="goToSchedule(restaurant.id)"
                                                        :restaurantId="restaurant.id"
                                                >
                                                    <v-list-item-title>Schedule</v-list-item-title>
                                                </v-list-item>

                                                <drivers-list-modal :restaurantId="restaurant.id"></drivers-list-modal>

                                                <new-post-modal :restaurantId="restaurant.id"></new-post-modal>

                                            </v-list>
                                        </v-menu>
                                    </div>
                                    </template>
                                </v-btn-toggle>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                    <new-restaurant-modal :thisAreaData="areaData"></new-restaurant-modal>
                </v-container>
            </div>

        </div>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import {STATUS_RESTAURANT_ACTIVE} from "../../store/areas";

    export default {
        name: "Areas",
        data: () => ({
            areaSelected: null,
            areaData: null,
            // areasList: [],
            localLoading: false,
            page: 1,
            per_page: 1,
            per_page_list: [1, 5, 10, 100, 1000],
        }),
        created() {
            this.$store.dispatch('fetchLocations');
            this.$store.dispatch('fetchCities'); // for modals
            // this.$store.dispatch('fetchAreas');
            // this.$store.dispatch('fetchRestaurants');
            this.$store.dispatch('fetchDrivers');
        },
        watch: {
            searchData() {
                this.onChangePage(1);
            }
        },
        computed: {
            ...mapGetters([
                'user',
                'cities',
                'error',
                'isUserLoggedIn',
                'loading',
                'areas',
                'restaurants',
                'drivers'
            ]),
            areasList() {
                let area_list = _.map(this.areas, area => {
                    area.restaurants = _.filter(this.restaurants, restaurant => area.id == restaurant.area_id && restaurant.status === STATUS_RESTAURANT_ACTIVE);
                    return area;
                });

                return area_list;
            },
            areasListPaged() {
                let start = this.per_page * (this.page - 1);
                let end = start + this.per_page;
                return this.areasList.slice(start, end);
            },
            total_pages() {
                return Math.ceil(this.areasList.length / this.per_page);
            },
        },
        methods: {
            editArea(data){
                console.log('method not call any time!');
                Object.keys(this.areas).forEach(key => {
                    if (this.areas[key].id === data.id) {
                        this.areas[key].name = data.name
                        this.areas[key].standardPayRate = data.standardPayRate
                        this.areas[key].weekendPayRate = data.weekendPayRate
                        this.areaData = this.areas[key]
                        this.areaSelected = this.areas[key].id
                    }
                })
                this.areasList = []
                Object.keys(this.areas).forEach(key => {
                    this.areasList.push(this.areas[key].name)
                })

            },
            clearArea(){
                this.areaSelected = null
                this.areaData = null
            },

            filterRestaurantsByArea(areaID) {
                this.localLoading = true
                this.areaSelected = null
                this.areaData = null

                Object.keys(this.areas).forEach(key => {
                    if (this.areas[key].id === areaID) {
                        this.areaData = this.areas[key];
                    }
                })

                this.localLoading = false;
            },
            deleteArea(area_item) {
                if (!confirm('Remove area ' + area_item.name + '?')) {
                    return; // exit
                }

                this.$store.dispatch('removeArea', area_item)
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    }).finally(() => {
                        this.localLoading = false;
                    });
            },
            deleteRestaurant(restaurant) {
                if (!confirm('Remove restaurant ' + restaurant.name + '?')) {
                    return; // exit
                }

                this.localLoading = true
                this.$store.dispatch('deleteRestaurant', restaurant)
                    .then(() => {
                    })
                    .catch(error => {
                        if(error && error.response && error.response.data && error.response.data.id) {
                            alert(error.response.data.id[0]);
                        }
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
            },
            onChangePage(page) {
                this.page = page;
            },
            goToSchedule(restaurant_id) {
                localStorage.setItem('redirrected_from_restaurants', restaurant_id);
                window.location = 'schedule'
            },
            getCityLabelById(city_id) {
                let city_item = _.find(this.cities, p => +p.id == +city_id);

                if (!city_item) {
                    return city_id;
                }

                return city_item.city_name;
            },
            onCangePerPage() {
                this.page = 1;
            }
        },
        filters: {
            formatFloat: function (num) {
                return Number(num).toFixed(2);
            },
        }
    }
</script>


<style scoped>

</style>
